// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__ByBMK","upload":"Small_upload__2WWE6","imageWrap":"Small_imageWrap__2SJnK","removeBtn":"Small_removeBtn__2GtPc"};